import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {DasUBoot} from "../DasUBoot";
import {gsap} from "gsap";
import {SymbolUtils} from "../utils/SymbolUtils";
import {StackedWildSymbol} from "../reels/symbols/StackedWildSymbol";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";

/**
 * Created by jonas on 2021-03-10.
 */

export class xNudge implements SimplePresentation {

    start(controller:SimplePresentationRunnerController):void {

        const tl:gsap.core.Timeline = gsap.timeline({onComplete:() => controller.finish()});

        const splitStacks:gsap.core.Timeline[] = [];
        const nudges = DasUBoot.model.clientData.xNudge;
        for (let data of nudges) {
            const w4Data = DasUBoot.reelView.getVisibleSymbolAt(data.reel, data.w4StartPos);
            const stackedSymbol = <StackedWildSymbol>w4Data.positionable;
            const fastNudge = !data.isInWin || DasUBoot.apiPlugin.settings.get(APISetting.FAST_SPIN, false);
            tl.add(SymbolUtils.getXNudgeAnimation(data, stackedSymbol, fastNudge));

            if (data.isInWin) {
                const split = stackedSymbol.nudgeComplete();
                split.add(() => {DasUBoot.reelView.reels[data.reel].replaceVisibleSymbol(data.w4EndPos, "W", false)}, 0);
                split.add(() => stackedSymbol.destroy());
                splitStacks.push(split);
            }
        }

        tl.add(splitStacks);

    }


    shouldRun():boolean {
        return DasUBoot.model.clientData.xNudge.length > 0;
    }


}